import React, {Fragment, useEffect, useState} from "react";
import {useForm} from "react-hook-form";

import HookSubFormChildDetails from "root/Base/HookFormComponents/HookSubFormChildDetails";
import {SaveButton} from "root/Modals/SaveButton";

const Page4 = ({formData, notify }) =>
{
    const { reset, resetField, register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                ... formData,
            }
        });

    const onSubmit = (data) =>
    {
        notify ({ action: 'submit' } ) ;
    }

    const onClickSaveForm = (status) =>
    {
        handleSubmit(onSubmit)(status);
    }

    const acceptRow = () => {

        const controlProps = {
            control: control,
            register: register,
            watch: watch,
            formErrors: formErrors,
            readOnly: true
        }

        return (
            <form className='' onSubmit={handleSubmit(onSubmit)}>

                <HookSubFormChildDetails key='childDetailForm' {...controlProps} search={false} sectionName='header' isPost16={false} />

                <div className="button-row top-margin">
                    <SaveButton disabled={false} onClick={onClickSaveForm} kay={'sb'}>Confirm and restore pupil</SaveButton>
                </div>
            </form>
        )
    }

    return (
        <Fragment>
            {  acceptRow() }
        </Fragment>

    )
}

export default Page4 ;